(function () {
  'use strict';
  function eventInstant(date, time, zone) {
    if (typeof date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(date) || typeof time !== 'string' || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time) || !zone) return null;
    const wanted = date + 'T' + time + ':00';
    const wall = Date.parse(wanted + 'Z');
    if (!Number.isFinite(wall) || new Date(wall).toISOString().slice(0, 19) !== wanted) return null;
    try {
      const formatter = new Intl.DateTimeFormat('en-CA', {timeZone: zone, year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      const wallAt = stamp => {
        const parts = Object.fromEntries(formatter.formatToParts(stamp).map(p => [p.type,p.value]));
        return Date.parse(`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}Z`);
      };
      const offsets = new Set([-86400000,0,86400000].map(delta => wallAt(wall + delta) - wall - delta));
      const matches = [...offsets].map(offset => wall - offset).filter(stamp => wallAt(stamp) === wall);
      return matches.length === 1 ? matches[0] : null;
    } catch (_) { return null; }
  }
  function nextEvent(config, now) {
    if (config.enabled === false) return null;
    const additional = Array.isArray(config.additional) ? config.additional : [];
    return [config, ...additional].filter(item => item && !item.review_required).map(item => {
      const timezone = item.timezone || config.timezone;
      const timestamp = eventInstant(item.date, item.start_time || item.time || config.time, timezone);
      return {timestamp, timezone};
    }).filter(item => item.timestamp !== null && item.timestamp > now).sort((a,b) => a.timestamp - b.timestamp)[0] || null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {eventInstant, nextEvent};
  if (typeof document === 'undefined') return;
  function init(host) {
    const root = host.querySelector('instant-layout')?.shadowRoot;
    if (!root || host.dataset.kitReady) return;
    host.dataset.kitReady = 'true';
    const form = root.querySelector('#pb-buy form');
    let commerce = {};
    try { commerce = JSON.parse(root.querySelector('[data-kit-commerce]')?.textContent || '{}'); } catch (_) {}
    function syncVariant() {
      if (!form || !Array.isArray(commerce.variants)) return;
      const selected = [...form.querySelectorAll('[data-kit-option]:checked')].sort((a,b) => Number(a.dataset.kitOption) - Number(b.dataset.kitOption)).map(el => el.value);
      const variant = selected.length ? commerce.variants.find(v => v.options.length === selected.length && v.options.every((value,index) => value === selected[index])) : commerce.variants[0];
      const id = form.querySelector('[name="id"]');
      if (id) { id.value = variant ? String(variant.id) : ''; id.disabled = !variant; }
      root.querySelectorAll('[data-kit-price]').forEach(el => { el.textContent = variant?.price || commerce.unavailable; });
      root.querySelectorAll('[data-kit-compare]').forEach(el => { el.hidden = !variant?.compare; el.textContent = variant?.compare || ''; });
      root.querySelectorAll('[data-kit-submit]').forEach(el => { el.disabled = !variant?.available; el.textContent = variant ? (variant.available ? commerce.add : commerce.sold) : commerce.unavailable; });
      root.querySelectorAll('[data-kit-quantity]').forEach(el => { el.hidden = !variant?.available; });
    }
    if (form) {
      form.addEventListener('change', event => { if (event.target.matches('[data-kit-option]')) syncVariant(); });
      form.addEventListener('submit', event => { if (form.querySelector('[data-kit-submit]')?.disabled) event.preventDefault(); });
      syncVariant();
    }
    let config = {};
    try { config = JSON.parse(root.querySelector('[data-kit-schedule]')?.textContent || '{}'); } catch (_) {}
    let timer;
    function refresh() {
      if (!host.isConnected) { clearTimeout(timer); return; }
      const now = Date.now();
      const next = nextEvent(config, now);
      root.querySelectorAll('[data-kit-upcoming]').forEach(el => { el.hidden = !next; });
      if (next) {
        const values = {
          date_short: new Intl.DateTimeFormat('en-US',{timeZone:next.timezone,month:'long',day:'numeric',year:'numeric'}).format(next.timestamp),
          weekday: new Intl.DateTimeFormat('en-US',{timeZone:next.timezone,weekday:'long'}).format(next.timestamp),
          date: new Intl.DateTimeFormat('en-US',{timeZone:next.timezone,weekday:'long',month:'long',day:'numeric',year:'numeric'}).format(next.timestamp),
          time: new Intl.DateTimeFormat('en-US',{timeZone:next.timezone,hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(next.timestamp),
          pacific: new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(next.timestamp)
        };
        root.querySelectorAll('[data-kit-event]').forEach(el => {
          el.textContent = values[el.dataset.kitEvent] || '';
          if (el.tagName === 'TIME') el.dateTime = new Date(next.timestamp).toISOString();
        });
      }
      let count = 0;
      const upcoming = [];
      root.querySelectorAll('[data-related-event]').forEach(el => {
        const instant = eventInstant(el.dataset.date, el.dataset.time, el.dataset.timezone);
        const show = instant !== null && instant > now && count < 4;
        el.hidden = !show;
        if (show) { count++; upcoming.push(instant); }
      });
      root.querySelectorAll('[data-related-events]').forEach(el => { el.hidden = count === 0; });
      clearTimeout(timer);
      if (next) upcoming.push(next.timestamp);
      if (upcoming.length) timer = setTimeout(refresh, Math.min(2147483647, Math.max(1, Math.min(...upcoming) - now + 50)));
    }
    refresh();
    document.addEventListener('visibilitychange', () => { if (!document.hidden && host.isConnected) refresh(); });
    const anchor = root.querySelector('#pb-buy');
    const bar = root.querySelector('#pb-sticky');
    if (anchor && bar) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        bar.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      observer.observe(anchor);
    }
  }
  function boot() { document.querySelectorAll('[data-pb-tasting-kit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
